import { useState, useEffect } from 'react'
import ReactTooltip from 'react-tooltip'
import { TEXTURES, PickerContainer, TilePickerStyled } from './SkinImagePicker'

const TileViewer = ({ texName, texURL, niceName }) => {
  const [renderTooltip, setRenderTooltip] = useState(false)

  useEffect(() => {
    setRenderTooltip(true)
  })

  return (
    <>
      <TilePickerStyled data-tip data-for={texName}>
        <img src={texURL} width={128} height={128} />
      </TilePickerStyled>

      {renderTooltip && (
        <ReactTooltip place='top' type='light' className='tooltip' effect='solid' id={texName}>
          <span>{niceName}</span>
        </ReactTooltip>
      )}
    </>
  )
}

const SkinViewer = ({ skin }) => {
  return (
    <PickerContainer>
      {
        TEXTURES.map(t => (
          <TileViewer
            texName={t[0]}
            niceName={t[1]}
            texURL={skin.textures[t[0]] || `/textures/${t[0]}.png`}
            key={t[0]}
          />
        ))
      }
    </PickerContainer>
  )
}

export default SkinViewer
